(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jadyk-jellyluxe"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('jelly-quick-buy')) {
  customElements.define('jelly-quick-buy', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const form = this.querySelector('form');
      const select = this.querySelector('select');
      const button = this.querySelector('button');
      const status = this.querySelector('[role="status"]');
      const cartLink = this.querySelector('.jkl-view-cart');
      select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        if (option.dataset.price) this.closest('.jkl-product').querySelector('.jkl-product-price').textContent = option.dataset.price;
        status.textContent = '';
      });
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (this.busy || !form.reportValidity()) return;
        this.busy = true;
        button.disabled = true;
        button.textContent = this.dataset.adding;
        status.textContent = '';
        const body = new FormData(form);
        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const sections = cart && typeof cart.getSectionsToRender === 'function' ? cart.getSectionsToRender().map(s => s.id) : ['cart-icon-bubble'];
        body.set('sections', sections.join(','));
        body.set('sections_url', window.location.pathname);
        if (cart && typeof cart.setActiveElement === 'function') cart.setActiveElement(button);
        try {
          const response = await fetch(form.action.replace(/\/$/, '') + '.js', {
            method: 'POST', headers: { Accept: 'application/json' }, body
          });
          const result = await response.json();
          if (!response.ok || result.status) {
            status.textContent = result.description || this.dataset.error;
            return;
          }
          status.textContent = this.dataset.added;
          cartLink.hidden = false;
          if (cart && typeof cart.renderContents === 'function' && sections.every(id => result.sections && result.sections[id])) {
            try {
              cart.classList.remove('is-empty');
              cart.renderContents(result);
            } catch (_) {
              cartLink.hidden = false;
            }
          } else if (result.sections && result.sections['cart-icon-bubble']) {
            const icon = document.getElementById('cart-icon-bubble');
            const doc = new DOMParser().parseFromString(result.sections['cart-icon-bubble'], 'text/html');
            const content = doc.querySelector('.shopify-section');
            if (icon && content) icon.innerHTML = content.innerHTML;
          }
        } catch (_) {
          status.textContent = this.dataset.error;
          cartLink.hidden = false;
        } finally {
          this.busy = false;
          button.disabled = false;
          button.textContent = this.dataset.add;
        }
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
